import * as React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Header from '../Header/Header';
import PreLoginNavigationBar from '../NavigationBar/PreLoginNavigationBar';
import Footer from '../Footer/Footer';

const useStyles = makeStyles((theme) => ({
    root:{
        padding:10,
    }
}));

const PreLoginTemplate=(props)=>{
    const {children}=props
const classes=useStyles()
return (
       <>
          <Header />
          <PreLoginNavigationBar />
          <div className={classes.root}>
              {children}
          </div>
          <Footer />
       </>
  );
};

export default PreLoginTemplate;